import React, { useState, useEffect } from "react";
import { Button, Input, Select } from "antd";
import {
  DoubleLeftOutlined,
  LeftOutlined,
  RightOutlined,
  DoubleRightOutlined,
  StepBackwardOutlined,
  StepForwardOutlined,
} from "@ant-design/icons";
import "./CustomPagination.css";

const CustomPagination = ({
  current = 1,
  total = 0,
  pageSize = 10,
  onChange,
  className = "",
  showSizeChanger = false,
  pageSizeOptions = ['10', '20', '50', '100']
}) => {
  const totalPages = Math.max(1, Math.ceil(total / pageSize)); // Ensure at least 1 page
  const [inputValue, setInputValue] = useState(current);

  const handlePageChange = (page) => {
    if (page >= 1 && page <= totalPages && onChange) {
      onChange(page, pageSize);
    }
  };

  const handleInputChange = (e) => {
    const value = parseInt(e.target.value) || 1;
    setInputValue(value);
  };

  const handleInputKeyPress = (e) => {
    if (e.key === 'Enter') {
      handlePageChange(inputValue);
    }
  };

  const handleInputBlur = () => {
    handlePageChange(inputValue);
  };

  useEffect(() => {
    setInputValue(current);
  }, [current]);

  // Don't render if there's no data (total === 0) and we're not showing size changer
  // Or if there's only one page and we're not showing size changer
  if ((total === 0 && !showSizeChanger) || (totalPages <= 1 && !showSizeChanger)) {
    return null;
  }

  return (
  <div className={`pagination-container ${className} gx-mx-auto`}>
    <div className="custom-pagination" style={{
    justifyContent: showSizeChanger ? "space-between" : "center",
  }}>
      {showSizeChanger && <div></div>}
      {(total > 0 || showSizeChanger) && (
        <div className="paginationButtons">
          <Button
            className="pagination-btn first gx-mr-0 gx-mb-0"
            onClick={() => handlePageChange(1)}
            disabled={current === 1 || total === 0}
            icon={<StepBackwardOutlined />}
          />
          <Button
            className="pagination-btn prev gx-mb-0"
            onClick={() => handlePageChange(current - 1)}
            disabled={current === 1 || total === 0}
            icon={<LeftOutlined />}
          />
          <span className="pagination-text">Page</span>
          <Input
            className="pagination-input"
            value={inputValue}
            onChange={handleInputChange}
            onKeyPress={handleInputKeyPress}
            onBlur={handleInputBlur}
            disabled={total === 0}
          />
          <span className="pagination-text">of</span>
          <span className="pagination-total">{totalPages}</span>
          <Button
            className="pagination-btn next gx-mb-0 gx-mr-0"
            onClick={() => handlePageChange(current + 1)}
            disabled={current === totalPages || total === 0}
            icon={<RightOutlined />}
          />
          <Button
            className="pagination-btn last gx-mb-0"
            onClick={() => handlePageChange(totalPages)}
            disabled={current === totalPages || total === 0}
            icon={<StepForwardOutlined />}
          />
        </div>
      )}

        {showSizeChanger && (
          <div className="pagination-size-changer">
            <span className="pagination-text">Records per page:</span>
            <Select
              value={pageSize}
              style={{ width: 80, marginLeft: 8 }}
              onChange={(value) => {
                if (onChange) {
                  onChange(1, value); // Reset to page 1 when changing page size
                }
              }}
              options={pageSizeOptions.map(size => ({
                value: parseInt(size),
                label: size
              }))}
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default CustomPagination;